<template>
  <div class="app-container">


    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>拼团产品列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索栏 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
        <el-form-item label="商品名称" prop="title">
          <el-input
                  v-model="queryParams.title"
                  placeholder="请输入商品名称"
                  clearable
                  style="width: 200px"
                  @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="商品分类" prop="categoryId">
          <el-cascader
                  v-model="queryParams.categoryId"
                  :options="categoryOptions"
                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"
                  placeholder="请选择分类"
                  clearable
                  style="width: 200px"
          />
        </el-form-item>

        <el-form-item label="商品状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width: 120px">
            <el-option label="全部" value="" />
            <el-option label="上架" :value="1" />
            <el-option label="下架" :value="0" />
            <el-option label="待审核" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间" prop="createTime">
          <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 240px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 操作栏 -->
    <el-card class="operate-card" shadow="never">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
<!--          v-hasPermi="['goods:add']"-->
          <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="handleAdd"

          >
            新增
          </el-button>
        </el-col>
        <el-col :span="1.5">
<!--          v-hasPermi="['goods:edit']"-->
          <el-button
                  type="success"
                  icon="el-icon-edit"
                  :disabled="single"
                  @click="handleUpdate"

          >
            修改
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
                  type="danger"
                  icon="el-icon-delete"
                  :disabled="multiple"
                  @click="handleDelete"
                  v-hasPermi="['goods:remove']"
          >
            删除
          </el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
                  type="warning"
                  icon="el-icon-download"
                  @click="handleExport"
                  v-hasPermi="['goods:export']"
          >
            导出
          </el-button>
        </el-col>

        <!-- 批量操作 -->
        <el-col :span="1.5" class="batch-operate">
          <el-dropdown @command="handleBatchCommand">
            <el-button>
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchOnSale" icon="el-icon-circle-check">
                批量上架
              </el-dropdown-item>
              <el-dropdown-item command="batchOffSale" icon="el-icon-circle-close">
                批量下架
              </el-dropdown-item>
              <el-dropdown-item command="batchDelete" icon="el-icon-delete">
                批量删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>

        <!-- 快捷筛选 -->
        <el-col :span="1.5">
          <el-dropdown @command="handleQuickFilter">
            <el-button>
              快捷筛选<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="hot" icon="el-icon-star">
                热销商品
              </el-dropdown-item>
              <el-dropdown-item command="recommend" icon="el-icon-thumb">
                推荐商品
              </el-dropdown-item>
              <el-dropdown-item command="new" icon="el-icon-time">
                新品商品
              </el-dropdown-item>
              <el-dropdown-item command="lowStock" icon="el-icon-warning">
                低库存商品
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </el-card>

    <!-- 商品列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
              v-loading="loading"
              :data="goodsList"
              @selection-change="handleSelectionChange"
              @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55" align="center" />

        <el-table-column label="商品图片" align="center" width="120">
          <template slot-scope="scope">
            <div class="goods-image">
              <el-image
                      :src="scope.row.images[0]"
                      :preview-src-list="scope.row.images"
                      fit="cover"
                      class="goods-thumb"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </template>
        </el-table-column>

        <el-table-column
                label="商品名称"
                align="center"
                prop="title"
                width="300"
                :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div class="goods-title">
              <span class="title-text">{{ scope.row.title }}</span>
              <div class="goods-tags">
                <el-tag v-if="scope.row.isHot" size="mini" type="danger">热销</el-tag>
                <el-tag v-if="scope.row.isRecommend" size="mini" type="success">推荐</el-tag>
                <el-tag v-if="scope.row.isNew" size="mini" type="warning">新品</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="分类" align="center" prop="categoryName" width="120" />

        <el-table-column label="价格" align="center" width="180">
          <template slot-scope="scope">
            <div class="goods-price">
              <div class="price-item">
                <span class="price-label">原价：</span>
                <span class="original-price">¥{{ scope.row.originalPrice }}</span>
              </div>
              <div class="price-item">
                <span class="price-label">现价：</span>
                <span class="current-price">¥{{ scope.row.currentPrice }}</span>
              </div>
              <div class="price-item">
                <span class="price-label">拼团价：</span>
                <span class="group-price">¥{{ scope.row.groupPrice }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="库存/销量" align="center" width="120">
          <template slot-scope="scope">
            <div class="stock-sales">
              <div>库存：{{ scope.row.stock }}</div>
              <div>销量：{{ scope.row.sales }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="拼团设置" align="center" width="120">
          <template slot-scope="scope">
            <div class="group-setting">
              <div>{{ scope.row.groupSize }}人团</div>
              <div v-if="scope.row.activityCount > 0">
                <el-tag size="mini" type="info">{{ scope.row.activityCount }}个活动</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change="handleStatusChange(scope.row)"
            />
          </template>
        </el-table-column>

        <el-table-column label="创建时间" align="center" prop="createTime" width="160">
          <template slot-scope="scope">
            <span>{{ (scope.row.createTime) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="220" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row)"
                    v-hasPermi="['goods:query']"
            >
              查看
            </el-button>
            <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click="handleUpdate(scope.row)"
                    v-hasPermi="['goods:edit']"
            >
              编辑
            </el-button>
            <el-button
                    type="text"
                    icon="el-icon-connection"
                    @click="handleActivity(scope.row)"
                    v-hasPermi="['activity:manage']"
            >
              拼团活动
            </el-button>
            <el-dropdown @command="(command) => handleMoreCommand(command, scope.row)">
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="sku" icon="el-icon-set-up">
                  SKU管理
                </el-dropdown-item>
                <el-dropdown-item command="copy" icon="el-icon-copy-document">
                  复制商品
                </el-dropdown-item>
                <el-dropdown-item command="delete" icon="el-icon-delete">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getList"
      />
    </el-card>

    <!-- 添加或修改商品对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-tabs v-model="activeTab">
          <!-- 基本信息 -->
          <el-tab-pane label="基本信息" name="basic">
            <el-form-item label="商品名称" prop="title">
              <el-input v-model="form.title" placeholder="请输入商品名称" />
            </el-form-item>

            <el-form-item label="商品分类" prop="categoryId">
              <el-cascader
                      v-model="form.categoryId"
                      :options="categoryOptions"
                      :props="{ checkStrictly: true, value: 'id', label: 'name' }"
                      placeholder="请选择商品分类"
                      style="width: 100%"
              />
            </el-form-item>

            <el-form-item label="商品主图" prop="images">
              <el-upload
                      action="#"
                      list-type="picture-card"
                      :file-list="imageList"
                      :auto-upload="false"
                      :limit="5"
                      :on-exceed="handleExceed"
                      :on-remove="handleRemove"
                      :on-change="handleImageChange"
                      :before-upload="beforeImageUpload"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  建议尺寸800*800，最多上传5张图片，支持jpg/png格式
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="商品视频">
              <el-upload
                      class="video-uploader"
                      action="#"
                      :show-file-list="false"
                      :before-upload="beforeVideoUpload"
                      :on-change="handleVideoChange"
              >
                <video v-if="form.video" :src="form.video" class="video-preview" controls></video>
                <div v-else class="video-uploader-trigger">
                  <i class="el-icon-plus"></i>
                  <div>上传视频</div>
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="商品描述" prop="description">
              <el-input
                      v-model="form.description"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入商品描述"
              />
            </el-form-item>

            <el-form-item label="商品详情" prop="detail">

            </el-form-item>
          </el-tab-pane>

          <!-- 价格库存 -->
          <el-tab-pane label="价格库存" name="price">
            <el-form-item label="原价" prop="originalPrice">
              <el-input-number
                      v-model="form.originalPrice"
                      :min="0"
                      :precision="2"
                      :step="0.1"
                      controls-position="right"
                      style="width: 200px"
              />
            </el-form-item>

            <el-form-item label="现价" prop="currentPrice">
              <el-input-number
                      v-model="form.currentPrice"
                      :min="0"
                      :precision="2"
                      :step="0.1"
                      controls-position="right"
                      style="width: 200px"
              />
            </el-form-item>

            <el-form-item label="拼团价" prop="groupPrice">
              <el-input-number
                      v-model="form.groupPrice"
                      :min="0"
                      :precision="2"
                      :step="0.1"
                      controls-position="right"
                      style="width: 200px"
              />
              <span class="price-tip">此价格为默认拼团价，可在拼团活动中单独设置</span>
            </el-form-item>

            <el-form-item label="成团人数" prop="groupSize">
              <el-input-number
                      v-model="form.groupSize"
                      :min="2"
                      :max="100"
                      controls-position="right"
                      style="width: 120px"
              />
            </el-form-item>

            <el-form-item label="总库存" prop="stock">
              <el-input-number
                      v-model="form.stock"
                      :min="0"
                      controls-position="right"
                      style="width: 120px"
              />
            </el-form-item>

            <el-form-item label="商品重量" prop="weight">
              <el-input-number
                      v-model="form.weight"
                      :min="0"
                      :precision="2"
                      :step="0.1"
                      controls-position="right"
                      style="width: 120px"
              />
              <span class="unit">kg</span>
            </el-form-item>
          </el-tab-pane>

          <!-- 商品规格 -->
          <el-tab-pane label="商品规格" name="spec">
            <el-form-item label="规格设置">
              <div class="spec-form">
                <div class="spec-list">
                  <div
                          v-for="(spec, index) in form.specs"
                          :key="index"
                          class="spec-item"
                  >
                    <el-input
                            v-model="spec.name"
                            placeholder="规格名称"
                            style="width: 120px; margin-right: 10px"
                    />
                    <el-tag
                            v-for="(value, valueIndex) in spec.values"
                            :key="valueIndex"
                            closable
                            @close="removeSpecValue(index, valueIndex)"
                    >
                      {{ value }}
                    </el-tag>
                    <el-input
                            class="input-new-tag"
                            v-if="spec.inputVisible"
                            v-model="spec.inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="addSpecValue(index)"
                            @blur="addSpecValue(index)"
                    />
                    <el-button
                            v-else
                            class="button-new-tag"
                            size="small"
                            @click="showSpecInput(index)"
                    >
                      + 添加
                    </el-button>
                    <el-button
                            type="danger"
                            icon="el-icon-delete"
                            circle
                            size="mini"
                            @click="removeSpec(index)"
                    />
                  </div>
                </div>
                <el-button type="primary" icon="el-icon-plus" @click="addSpec">
                  添加规格
                </el-button>
              </div>
            </el-form-item>
          </el-tab-pane>

          <!-- 其他设置 -->
          <el-tab-pane label="其他设置" name="other">
            <el-form-item label="商品标签">
              <el-checkbox-group v-model="form.tags">
                <el-checkbox label="isHot">热销商品</el-checkbox>
                <el-checkbox label="isRecommend">推荐商品</el-checkbox>
                <el-checkbox label="isNew">新品商品</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="商品状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="0">下架</el-radio>
                <el-radio :label="2">待审核</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="活动时间" v-if="form.status === 1">
              <el-date-picker
                      v-model="form.activityTime"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 100%"
              />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 商品详情对话框 -->
    <el-dialog title="商品详情" :visible.sync="detailOpen" width="900px" append-to-body>
      <div v-if="detailData" class="goods-detail-dialog">
        <!-- 商品基本信息 -->
        <div class="detail-section">
          <h3 class="section-title">基本信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="商品名称">{{ detailData.title }}</el-descriptions-item>
            <el-descriptions-item label="商品分类">{{ detailData.categoryName }}</el-descriptions-item>
            <el-descriptions-item label="商品状态">
              <el-tag :type="detailData.status === 1 ? 'success' : 'danger'">
                {{ detailData.status === 1 ? '上架' : '下架' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ detailData.createTime }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 商品图片 -->
        <div class="detail-section">
          <h3 class="section-title">商品图片</h3>
          <el-row :gutter="10">
            <el-col
                    v-for="(image, index) in detailData.images"
                    :key="index"
                    :span="6"
                    style="margin-bottom: 10px"
            >
              <el-image
                      :src="image"
                      fit="cover"
                      style="width: 100%; height: 100px"
                      :preview-src-list="detailData.images"
              />
            </el-col>
          </el-row>
        </div>

        <!-- 价格信息 -->
        <div class="detail-section">
          <h3 class="section-title">价格信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="原价">¥{{ detailData.originalPrice }}</el-descriptions-item>
            <el-descriptions-item label="现价">¥{{ detailData.currentPrice }}</el-descriptions-item>
            <el-descriptions-item label="拼团价">¥{{ detailData.groupPrice }}</el-descriptions-item>
            <el-descriptions-item label="成团人数">{{ detailData.groupSize }}人</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 库存信息 -->
        <div class="detail-section">
          <h3 class="section-title">库存信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="总库存">{{ detailData.stock }}</el-descriptions-item>
            <el-descriptions-item label="总销量">{{ detailData.sales }}</el-descriptions-item>
            <el-descriptions-item label="商品重量">{{ detailData.weight }}kg</el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 商品详情 -->
        <div class="detail-section">
          <h3 class="section-title">商品详情</h3>
          <div class="detail-content" v-html="detailData.detail"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import { listGoods, getGoods, delGoods, addGoods, updateGoods, changeGoodsStatus } from '@/api/goods'
  // import { listCategory } from '@/api/category'

  export default {
    name: 'groupGoodsList',
    components: {  },
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 总条数
        total: 0,
        // 商品表格数据
        goodsList: [],
        // 分类选项
        categoryOptions: [],
        // 日期范围
        dateRange: [],
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          title: undefined,
          categoryId: undefined,
          status: undefined
        },
        // 排序参数
        sortParams: {},
        // 表单参数
        form: {
          id: undefined,
          title: undefined,
          categoryId: undefined,
          images: [],
          video: undefined,
          description: undefined,
          detail: undefined,
          originalPrice: 0,
          currentPrice: 0,
          groupPrice: 0,
          groupSize: 2,
          stock: 0,
          weight: 0,
          tags: [],
          status: 1,
          specs: [],
          activityTime: []
        },
        // 图片列表
        imageList: [],
        // 表单校验
        rules: {
          title: [
            { required: true, message: '商品名称不能为空', trigger: 'blur' }
          ],
          categoryId: [
            { required: true, message: '商品分类不能为空', trigger: 'blur' }
          ],
          originalPrice: [
            { required: true, message: '原价不能为空', trigger: 'blur' }
          ],
          currentPrice: [
            { required: true, message: '现价不能为空', trigger: 'blur' }
          ],
          groupPrice: [
            { required: true, message: '拼团价不能为空', trigger: 'blur' }
          ],
          stock: [
            { required: true, message: '库存不能为空', trigger: 'blur' }
          ]
        },
        // 弹出层标题
        title: '',
        // 是否显示弹出层
        open: false,
        // 是否显示详情弹出层
        detailOpen: false,
        // 详情数据
        detailData: null,
        // 当前激活的标签页
        activeTab: 'basic'
      }
    },
    created() {
      this.getList()
      this.getCategoryList()
    },
    methods: {
      // 获取商品列表
      getList() {
        this.loading = true
        this.$axios.groupListGoods(this.addDateRange(this.queryParams, this.dateRange)).then(response => {
          this.goodsList = response.rows
          this.total = response.total
          this.loading = false
        })
      },

      // 获取分类列表
      getCategoryList() {
        this.$axios.groupListGoodsCategory().then(response => {
          this.categoryOptions = this.handleTree(response.data, 'id', 'pid')
        })
      },

      // 搜索
      handleQuery() {
        this.queryParams.pageNum = 1
        this.getList()
      },

      // 重置
      resetQuery() {
        this.dateRange = []
        this.resetForm('queryForm')
        this.handleQuery()
      },

      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map(item => item.id)
        this.single = selection.length !== 1
        this.multiple = !selection.length
      },

      // 排序变化
      handleSortChange(column) {
        this.sortParams = {
          orderByColumn: column.prop,
          isAsc: column.order === 'ascending' ? 'asc' : 'desc'
        }
        this.getList()
      },

      // 新增按钮操作
      handleAdd() {
        //this.reset()
        this.open = true
        this.title = '添加商品'
      },

      // 修改按钮操作
      handleUpdate(row) {
        const goodsId = row.id || this.ids
        this.$axios.getGroupGoods(goodsId).then(response => {
          this.form = response.data
          this.imageList = (response.data.images || []).map((url, index) => ({
            url,
            name: `image_${index + 1}.jpg`
          }))
          this.open = true
          this.title = '修改商品'
        })
      },

      // 查看详情
      handleView(row) {
        this.$axios.getGroupGoods(row.id).then(response => {
          this.detailData = response.data
          this.detailOpen = true
        })
      },

      // 拼团活动管理
      handleActivity(row) {
        this.$router.push({
          path: '/activity/list',
          query: { goodsId: row.id }
        })
      },

      // 更多操作
      handleMoreCommand(command, row) {
        switch (command) {
          case 'sku':
            this.handleSku(row)
            break
          case 'copy':
            this.handleCopy(row)
            break
          case 'delete':
            this.handleDelete(row)
            break
        }
      },

      // SKU管理
      handleSku(row) {
        this.$router.push({
          path: '/goods/sku',
          query: { goodsId: row.id }
        })
      },

      // 复制商品
      handleCopy(row) {
        this.$confirm('确认要复制该商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.getGroupGoods(row.id).then(response => {
            const goodsData = response.data
            goodsData.title = `${goodsData.title} - 副本`
            goodsData.id = undefined
            this.$axios.getGroupGoods(goodsData).then(res => {
              console.log(res)
              this.$modal.msgSuccess('复制成功')
              this.getList()
            })
          })
        })
      },

      // 删除按钮操作
      handleDelete(row) {
        const goodsIds = row.id || this.ids
        this.$confirm('是否确认删除商品编号为"' + goodsIds + '"的数据项？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return this.$axios.delGroupGoods(goodsIds)
        }).then(() => {
          this.getList()
          this.$modal.msgSuccess('删除成功')
        }).catch(() => {})
      },

      // 批量操作
      handleBatchCommand(command) {
        if (!this.ids.length) {
          this.$modal.msgWarning('请先选择商品')
          return
        }

        switch (command) {
          case 'batchOnSale':
            this.batchChangeStatus(1)
            break
          case 'batchOffSale':
            this.batchChangeStatus(0)
            break
          case 'batchDelete':
            this.handleDelete()
            break
        }
      },

      // 批量修改状态
      batchChangeStatus(status) {
        const statusText = status === 1 ? '上架' : '下架'
        this.$confirm(`确认要${statusText}选中的商品吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const requests = this.ids.map(id =>
                  this.$axios.changeGroupGoodsStatus(id, status)
          )
          return Promise.all(requests)
        }).then(() => {
          this.getList()
          this.$modal.msgSuccess(`${statusText}成功`)
        }).catch(() => {})
      },

      // 快捷筛选
      handleQuickFilter(command) {
        this.resetQuery()
        switch (command) {
          case 'hot':
            this.queryParams.isHot = 1
            break
          case 'recommend':
            this.queryParams.isRecommend = 1
            break
          case 'new':
            this.queryParams.isNew = 1
            break
          case 'lowStock':
            this.queryParams.stockMin = 0
            this.queryParams.stockMax = 10
            break
        }
        this.getList()
      },

      // 状态修改
      handleStatusChange(row) {
        const text = row.status === 1 ? '上架' : '下架'
        this.$modal.confirm('确认要' + text + '该商品吗？').then(() => {
          return this.$axios.changeGroupGoodsStatus(row.id, row.status)
        }).then(() => {
          this.$modal.msgSuccess(text + '成功')
        }).catch(() => {
          row.status = row.status === 1 ? 0 : 1
        })
      },

      // 取消按钮
      cancel() {
        this.open = false
        this.reset()
      },

      // 表单重置
      reset() {
        this.form = {
          id: undefined,
          title: undefined,
          categoryId: undefined,
          images: [],
          video: undefined,
          description: undefined,
          detail: undefined,
          originalPrice: 0,
          currentPrice: 0,
          groupPrice: 0,
          groupSize: 2,
          stock: 0,
          weight: 0,
          tags: [],
          status: 1,
          specs: [],
          activityTime: []
        }
        this.imageList = []
        this.activeTab = 'basic'
        this.resetForm('form')
      },

      // 提交表单
      submitForm() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            // 处理图片数据
            this.form.images = this.imageList.map(item => item.url || item.response.url)

            // 处理规格数据
            this.form.specs = this.form.specs.map(spec => ({
              name: spec.name,
              values: spec.values
            }))

            // 处理活动时间
            if (this.form.activityTime && this.form.activityTime.length === 2) {
              this.form.startTime = this.form.activityTime[0]
              this.form.endTime = this.form.activityTime[1]
            }

            if (this.form.id != null) {
              this.$axios.updateGroupGoods(this.form).then(response => {
                console.log(response)
                this.$modal.msgSuccess('修改成功')
                this.open = false
                this.getList()
              })
            } else {
              this.$axios.addGroupGoods(this.form).then(response => {
                console.log(response)
                this.$modal.msgSuccess('新增成功')
                this.open = false
                this.getList()
              })
            }
          }
        })
      },

      // 图片上传相关方法
      handleExceed(files, fileList) {
        console.log(files,fileList)
        this.$message.warning(`最多只能上传 5 张图片`)
      },

      handleRemove(file, fileList) {
        this.imageList = fileList
      },

      handleImageChange(file, fileList) {
        this.imageList = fileList
      },

      beforeImageUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      },

      // 视频上传相关方法
      beforeVideoUpload(file) {
        const isVideo = file.type.includes('video/')
        const isLt50M = file.size / 1024 / 1024 < 50

        if (!isVideo) {
          this.$message.error('只能上传视频文件!')
          return false
        }
        if (!isLt50M) {
          this.$message.error('视频大小不能超过 50MB!')
          return false
        }
        return true
      },

      handleVideoChange(file) {
        if (file.status === 'ready') {
          const formData = new FormData()
          formData.append('file', file.raw)

          // 模拟上传，实际应该调用API
          this.form.video = URL.createObjectURL(file.raw)
        }
      },

      // 规格相关方法
      addSpec() {
        this.form.specs.push({
          name: '',
          values: [],
          inputVisible: false,
          inputValue: ''
        })
      },

      removeSpec(index) {
        this.form.specs.splice(index, 1)
      },

      showSpecInput(index) {
        this.form.specs[index].inputVisible = true
        //this.$nextTick(e=> {
          this.$refs.saveTagInput[index].$refs.input.focus()
        //})
      },

      addSpecValue(index) {
        const inputValue = this.form.specs[index].inputValue
        if (inputValue) {
          this.form.specs[index].values.push(inputValue)
        }
        this.form.specs[index].inputVisible = false
        this.form.specs[index].inputValue = ''
      },

      removeSpecValue(index, valueIndex) {
        this.form.specs[index].values.splice(valueIndex, 1)
      },

      // 导出
      handleExport() {
        this.download('/api/admin/goods/export', {
          ...this.queryParams,
          ...this.dateRange
        }, `goods_${new Date().getTime()}.xlsx`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .app-container {
    padding: 12px;
  }

  .search-card {
    margin-bottom: 20px;
  }

  .operate-card {
    margin-bottom: 20px;

    .batch-operate {
      margin-left: 10px;
    }
  }

  .table-card {
    .goods-image {
      .goods-thumb {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;

        .image-slot {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f7fa;
          color: #909399;
          font-size: 24px;
        }
      }
    }

    .goods-title {
      .title-text {
        display: block;
        margin-bottom: 5px;
        font-weight: 500;
      }

      .goods-tags {
        .el-tag {
          margin-right: 5px;
        }
      }
    }

    .goods-price {
      .price-item {
        margin-bottom: 3px;
        font-size: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .price-label {
          color: #999;
        }

        .original-price {
          text-decoration: line-through;
          color: #999;
        }

        .current-price {
          color: #f56c6c;
        }

        .group-price {
          color: #e6a23c;
        }
      }
    }

    .stock-sales {
      font-size: 12px;
      color: #666;
    }

    .group-setting {
      font-size: 12px;
      color: #666;
    }
  }

  .spec-form {
    .spec-list {
      margin-bottom: 20px;

      .spec-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .el-tag {
          margin-right: 5px;
          margin-bottom: 5px;
        }

        .input-new-tag {
          width: 90px;
          margin-right: 10px;
        }

        .button-new-tag {
          margin-right: 10px;
        }
      }
    }
  }

  .video-uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #409eff;
      }
    }

    .video-uploader-trigger {
      width: 178px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      color: #8c939d;
      font-size: 12px;

      i {
        font-size: 28px;
        display: block;
        margin-top: 10px;
      }
    }

    .video-preview {
      width: 178px;
      height: 100px;
      border-radius: 6px;
      object-fit: cover;
    }
  }

  .price-tip {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }

  .unit {
    margin-left: 5px;
    color: #666;
  }

  .goods-detail-dialog {
    .detail-section {
      margin-bottom: 20px;

      .section-title {
        margin-bottom: 10px;
        padding-bottom: 5px;
        border-bottom: 1px solid #eee;
        font-size: 16px;
        color: #333;
      }

      .detail-content {
        padding: 10px;
        border: 1px solid #eee;
        border-radius: 4px;
        max-height: 400px;
        overflow-y: auto;
      }
    }
  }
</style>
